import type { EntryPointComponent } from 'react-relay';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskFeedbackRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskFeedbackRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { LazyCsatSettingsPage } from '@jira/servicedesk__csat/src/LazyCsatSettingsPage.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskFeedbackSettings, {
	LazyProjectSettingsServiceDeskFeedbackSettings,
} from './ui/service-desk-feedback-settings/index.tsx';

const projectSettingsServicedeskFeedbackPageEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-project-settings-service-desk-feedback-settings", jiraSpaEntry: "async-project-settings-service-desk-feedback-settings" */ '@jira/spa-apps__project-settings-service-desk-feedback-settings/src/ServiceDeskFeedbackSettingsPage.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const projectSettingsServicedeskFeedbackRouteEntry: Route = createEntry(
	projectSettingsServicedeskFeedbackRoute,
	() => ({
		group: 'project-settings-servicedesk',

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_2') ? undefined : ServiceDeskFeedbackSettings,

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_2')
				? projectSettingsServicedeskFeedbackPageEntryPoint
				: undefined,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyProjectSettingsServiceDeskFeedbackSettings, LazyCsatSettingsPage],
		perfMetricKey: 'jsm-feedback-settings',

		meta: {
			reporting: {
				id: APP_NAMES.CSAT_CONFIG,
				packageName: toPackageName(APP_NAMES.CSAT_CONFIG),
				teamName: 'jsm-request-intake',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
